import * as React from 'react';
import cn from 'classnames';

type SectionType = {
  id?: string;
  container?: boolean;
  bg?: string;
  center?: boolean;
  relative?: boolean;
  paddingTop?: boolean | number;
  paddingBottom?: boolean | number;
  overflowHidden?: boolean;
  className?: string;
  sectionClassName?: string;
};

const Section = React.forwardRef<HTMLElement, React.PropsWithChildren<SectionType>>(
  (
    {
      id,
      container,
      bg,
      center,
      relative,
      paddingTop,
      paddingBottom,
      children,
      overflowHidden,
      className,
      sectionClassName
    },
    ref
  ) => (
    <section
      ref={ref}
      id={id}
      className={cn(
        'py-18 lg:py-20',
        `${bg}`,
        {
          'text-center': center,
          'pt-0 lg:pt-0': !paddingTop,
          'pb-0 lg:pb-0': !paddingBottom,
          'overflow-hidden': overflowHidden,
          relative
        },
        sectionClassName
      )}
    >
      <div className={cn({ container }, className)}>{children}</div>
    </section>
  )
);

Section.defaultProps = {
  id: '',
  container: true,
  bg: 'bg-transparent',
  center: false,
  relative: false,
  paddingTop: true,
  paddingBottom: true,
  overflowHidden: false
};

export default Section;
